import React, { useState } from 'react';

function MessageForm({ onAddMessage }) {
  const [otherMessage, setOtherMessage] = useState('');
  const [myMessage, setMyMessage] = useState('');

  const handleAddOtherMessage = () => {
    if (!otherMessage.trim()) return;
    onAddMessage("상대방 메시지", otherMessage);
    setOtherMessage('');
  };

  const handleAddMyMessage = () => {
    if (!myMessage.trim()) return;
    onAddMessage("내 메시지", myMessage);
    setMyMessage('');
  };

  return (
    <div className="flex space-x-4">
      {/* 상대방 메시지 입력 */}
      <div className="w-1/2">
        <label className="block mb-1 font-bold">상대방 메시지</label>
        <div className="flex space-x-2">
          <input
            type="text"
            className="w-full border border-gray-300 p-2 rounded"
            placeholder="상대방 메시지"
            value={otherMessage}
            onChange={(e) => setOtherMessage(e.target.value)}
          />
          <button
            onClick={handleAddOtherMessage}
            className="px-3 bg-blue-500 text-white rounded"
          >
            입력
          </button>
        </div>
      </div>

      {/* 내 메시지 입력 */}
      <div className="w-1/2">
        <label className="block mb-1 font-bold">내 메시지</label>
        <div className="flex space-x-2">
          <input
            type="text"
            className="w-full border border-gray-300 p-2 rounded"
            placeholder="내 메시지"
            value={myMessage}
            onChange={(e) => setMyMessage(e.target.value)}
          />
          <button
            onClick={handleAddMyMessage}
            className="px-3 bg-blue-500 text-white rounded"
          >
            입력
          </button>
        </div>
      </div>
    </div>
  );
}

export default MessageForm;
